<template>
  <div class="nav">
    <div class="flexContent">
      <img src="../assets/logo.png" alt="" class="logo" @click="goIndex">
      <div class="borderLine"></div>
      <div>
        <router-link to="/" v-bind:class="{ 'navText': true, 'active': this.$route.path === '/' ? true : false }">主页
        </router-link>
        <router-link to="/hkv" v-bind:class="{ 'navText': true, 'active': this.$route.path === '/hkv' ? true : false }">监控
        </router-link>
        <router-link to="/onlineSearch" v-bind:class="{ 'navText': true, 'active': this.$route.path === '/onlineSearch' ? true : false }" style="width: 120px;">在线查询
        </router-link>
        <router-link to="/warningSearch" v-bind:class="{ 'navText': true, 'active': this.$route.path === '/warningSearch' ? true : false }" style="width: 120px;">故障报警
        </router-link>
      </div>
    </div>

    <div class="user flexContent">
      <img src="../assets/user.png" alt="">
      <div>
        欢迎 {{username}}！
      </div>
      <div class="onLoginOut" @click="onLoginOut">退出</div>

      <div class="el-icon-caret-bottom"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "navTop",
  data(){
    return {
      username:''
    }
  },
  created(){
    this.username = sessionStorage.loginName
  },
  methods:{
    onLoginOut(){
      sessionStorage.clear()
      this.$router.replace({
        path:'/login'
      })
    },
    goIndex(){
      this.$router.replace({
        path:'/'
      })
    },
  },
}
</script>

<style scoped>
.borderLine {
  display: inline-block;
  width: 1px;
  height: 28px;
  background: #60F0FF;
  margin-left: 20px;
  margin-right: 30px;

}
.onLoginOut{
  cursor: pointer;
}
.nav {
  height: 7vh;
  background: #050B30;
  line-height: 7vh;
  display: flex;
  align-items: center;
  padding: 0 30px;
  justify-content: space-between;
}

.logo {
  width: 250px;
  /*margin-left: 30px;*/
}

.navText {
  font-size: 18px;
  color: #60F0FF;
  display: inline-block;
  width: 80px;
  height: 65px;
  text-align: center;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
}

.navText.active {
  font-weight: 600;
  background-image: url("../assets/navActive.png");
  background-repeat: no-repeat;
  background-position: center bottom;
  background-size: 100%;

}
.flexContent{
  display: flex;
  align-items: center;
}
.user img{
  width: 25px;
  display: flex;
  align-items: center;
  margin-right: 10px;
}
.user{
  display: flex;
  align-items: center;
  color: #fff;
  font-size: 14px;
}
</style>
